import routesLimited from '@/constants/routesLimited'
import type { RouteRecordRaw } from 'vue-router'

export const notificationDocuments: RouteRecordRaw = {
	component: () => import('components/elements/Notifications/Documents.vue'),
	meta: {
		title: 'Neue Dokumente',
		auth: true,
		subs: [routesLimited.subMethods.notification_document],
	},
	name: 'notificationDocuments',
	path: '/notifications/documents',
	props: true,
}

export const notificationView: RouteRecordRaw = {
	name: 'notificationView',
	component: () => import('elements/Notifications/View.vue'),
	path: '/notifications/:id',
	props: true,
	meta: {
		subs: [routesLimited.subModules.notifications],
	},
}
